import AuthGuard from 'utils/route-guard/AuthGuard';

const AnonRoutes = {
  path: '*',
  element: (
    <AuthGuard>
      <></>
    </AuthGuard>
  )
};

export default AnonRoutes;
